

const config = {
  apiUrl: "https://maniera-digital.vercel.app"
};

export default config;